var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-md"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.5 16.6665L13.875 13.0415M15.8333 8.33317C15.8333 12.0151 12.8486 14.9998 9.16667 14.9998C5.48477 14.9998 2.5 12.0151 2.5 8.33317C2.5 4.65127 5.48477 1.6665 9.16667 1.6665C12.8486 1.6665 15.8333 4.65127 15.8333 8.33317Z",
    stroke: "current",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMd);
export default __webpack_public_path__ + "static/media/search-md.def67d89f92d889c7d86a0bc7f4bf460.svg";
export { ForwardRef as ReactComponent };